// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1olMp","textStyle":"Footer_textStyle__32C4p","Trademark":"Footer_Trademark__3xKiS"};